import React from 'react';
const parcours = [{
  period: 'La danse',
  text: 'Formation en modern jazz et contemporain, dont le CNDC, puis diplôme d’État de professeur de danse contemporaine et plusieurs années d’enseignement.'
}, {
  period: 'Le Pilates',
  text: 'Une suite logique du travail corporel : je deviens éducatrice sportive et enseigne la méthode sur tapis et avec matériel.'
}, {
  period: 'Le stretching postural',
  text: 'Formation à la méthode Jean-Pierre Moreau, obtention du SP3 et pratique comme praticienne depuis plusieurs années.'
}, {
  period: 'Munz Floor®',
  text: 'Coach certifiée : un travail au sol qui apaise le système nerveux et complète les deux approches précédentes.'
}];
export function APropos() {
  return <section className="bg-cream" data-id="element-23" data-mp="q301vowx5f5u">
      <div className="mx-auto grid max-w-page gap-12 px-6 py-20 lg:grid-cols-12 lg:gap-16 lg:px-10 lg:py-28" data-id="element-24" data-mp="3fqh9sza06t4b">
        <div className="lg:col-span-5" data-id="element-25" data-mp="3apthmaa1g68i">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/e374f21c-6000-4387-beee-a96f04e7c61f.jpg" alt="Portrait de Christine Velluet assise dans son studio" className="aspect-[4/5] w-full object-cover" data-id="element-26" data-mp="3asxstrlx828o" />
        </div>

        <div className="lg:col-span-7 lg:pt-4" data-id="element-27" data-mp="2l9seozyi42j7">
          <h2 className="font-serif text-3xl font-light leading-tight text-ink sm:text-[2.75rem]" data-id="element-28" data-mp="2q953hq8xnjof">
            Je m’appelle Christine Velluet
          </h2>
          <p className="mt-6 max-w-xl text-[1.0625rem] leading-relaxed text-ink/75" data-id="element-29" data-mp="2bj7mbu9f7u8q">
            Mon histoire professionnelle commence avec la danse. Elle m’a appris à regarder un corps en mouvement,
            à repérer ce qui bloque et ce qui peut se libérer. Tout ce que j’enseigne aujourd’hui vient de là :
            de la précision, du temps, et aucun jugement.
          </p>

          <ol className="mt-12 space-y-8 border-l border-ink/15 pl-7" data-id="element-30" data-mp="1sm6em1ohfg13">
            {parcours.map(step => <li key={step.period} className="relative" data-id="element-31" data-mp="1xjy3emttym12">
                <span className="absolute -left-[calc(1.75rem+3.5px)] top-2 h-[7px] w-[7px] rounded-full bg-sage-deep" aria-hidden="true" data-id="element-32" data-mp="1egcqysocnlnq" />
                <h3 className="font-serif text-lg text-ink" data-id="element-33" data-mp="14prxfjnj97bo">{step.period}</h3>
                <p className="mt-1.5 max-w-xl text-[0.95rem] leading-relaxed text-ink/65" data-id="element-34" data-mp="zr8bvkcupxju">{step.text}</p>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}